import classNames from "classnames";
import React, { useEffect, useState } from "react";
import styles from "./footer.module.scss";
import Image from "next/legacy/image";
import Link from "next/link";
const FooterAddress = () => {
  const currentDate = new Date();
  const expirationDate1 = new Date("2023-07-01");
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return mounted ? (
    <div className={styles["footer-address"]}>
      <div className={styles["container"]}>
        <div className="row">
          <div className={classNames(styles["col-w-20"], "col-md-4 d-lg-block d-none")}>
            <div className={styles.title}>Trợ giúp</div>
            <ul>
              <li>
                <a
                  href="https://help.sapo.vn/?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_trung_tam_tro_giup"
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                >
                  Trung tâm trợ giúp
                </a>
              </li>
              <li>
                <a href="https://help.sapo.vn/cac-hinh-thuc-thanh-toan-khi-su-dung-dich-vu-cua-sapo" rel="nofollow noopener" target="_blank">Hình thức thanh toán</a>
              </li>
              <li>
                <a
                  href="https://help.sapo.vn/tong-quan-ve-tai-khoan-dang-nhap-phan-mem-sapo?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_huong_dan_dang_nhap_sapo"
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                >
                  Hướng dẫn đăng nhập Sapo
                </a>
              </li>
              <li>
                <a
                  href="https://help.sapo.vn/dieu-khoan-va-dieu-kien-su-dung?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_dieu_khoan_dieu_kien_su_dung"
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                >
                  Điều khoản & Điều kiện sử dụng
                </a>
              </li>
              <li>
                <a
                  href="https://help.sapo.vn/chinh-sach-bao-ve-du-lieu-ca-nhan?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_chinh_sach_bao_ve_du_lieu_ca_nhan"
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                >
                  Chính sách bảo vệ dữ liệu cá nhân
                </a>
              </li>
              <li>
                <a
                  href="https://drive.google.com/file/d/1rxszgN-JqCDLALdT0rSouOKmLPNoTFC1/view"
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                >
                  Dịch vụ hoàn thiện website
                </a>
              </li>
              <li>
                <a
                  href="https://www.sapo.vn/lien-he.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_brand_lien_he"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  Liên hệ
                </a>
              </li>
            </ul>
          </div>
          <div className={classNames(styles["col-w-20"], " col-md-4")}>
            <div className={styles.title}>Tổng đài hỗ trợ</div>
            <ul className="contact">
              <li>Tư vấn dịch vụ: <b>1800 6750</b></li>
              <li>Hỗ trợ sử dụng: <b>1900 6750</b></li>
              <li>Email: support@sapo.vn</li>
              <li>Từ 7h00 – 22h00 các ngày từ thứ 2 đến Chủ nhật</li>
            </ul>
          </div>
          <div className={classNames(styles["col-w-20"], "col-lg col-md-4")}>
            <div className="row">
              <div className={classNames(styles["col-sm-6"], "col-12")}>
                <div className={styles.title}>Hợp tác</div>
                <ul>
                  <li>
                    <a href="https://www.sapo.vn/partner.html?campaign=footer_app&utm_campaign=footer_13022025&utm_source=app&utm_medium=external&utm_content=link_san_pham_nha_phat_trien_ung_dung" target="_blank" rel="noopener noreferrer">
                      Liên hệ hợp tác
                    </a>
                  </li>

                  <li>
                    <a href="https://www.sapo.vn/nha-dau-tu.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_danh_cho_nha_dau_tu" target="_blank" rel="noopener noreferrer">
                      Dành cho nhà đầu tư
                    </a>
                  </li>
                  <li>
                    <a href="https://www.sapo.vn/hop-tac-truong-dai-hoc.html?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_san_pham_danh_cho_truong_dai_hoc" target="_blank" rel="noopener noreferrer">
                      Dành cho trường Đại Học
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className={classNames(styles["col-w-40"], "col-md-8")}>
            <div className={styles.title}>Liên hệ</div>
            <ul className={styles.social}>
              <li className={classNames(styles["icon-facebook"])}>
                <a href="https://www.facebook.com/sapo.vn/?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_facebook" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <i className="fa fa-facebook-square"></i>
                </a>
              </li>
              <li className={classNames(styles["icon-youtube"])}>
                <a href="https://www.youtube.com/@sapo-vietnam/featured?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=external&utm_content=link_san_pham_youtube" target="_blank" rel="noopener noreferrer" aria-label="Youtube">
                  <i className="fa fa-youtube"></i>
                </a>
              </li>
              <li className={classNames(styles["icon-blog"])}>
                <a href="https://www.sapo.vn/blog?campaign=footer_blog&utm_campaign=footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_brand_sapo_blog" target="_blank" rel="noopener noreferrer" aria-label="Blog sapo">
                  <i className="fa fa-weixin"></i>
                </a>
              </li>
            </ul>
            <div className={styles["contact-info"]}>
              <p className="text-uppercase">Công ty cổ phần công nghệ Sapo (Sapo Technology JSC)</p>
              <p>
                <span>
                  Trụ sở <i className="fa fa-map-marker"></i>{" "}
                </span>
                Tầng 6, Tòa Ladeco, 266 Đội Cấn, Quận Ba Đình, TP Hà Nội
              </p>
              <p>
                <span className="d-xl-inline d-block">Chi nhánh </span>
                <i className="fa fa-map-marker"></i> Lầu 5, Tòa Lữ Gia, Số 70 Lữ Gia, Quận 11, TP HCM
              </p>
              <p>
                <span style={{ visibility: "hidden" }} className="d-none d-xl-inline">
                  Chi nhánh{" "}
                </span>
                <i className="fa fa-map-marker"></i> Số 83 Xô Viết Nghệ Tĩnh, Quận Cẩm Lệ, TP Đà Nẵng
              </p>
              <p>
                <span style={{ visibility: "hidden" }} className="d-none d-xl-inline">
                  Chi nhánh{" "}
                </span>
                <i className="fa fa-map-marker"></i>{" "}
                <Link href="https://www.sapo.vn/lien-he.html?campaign=footer_blog&utm_campaign=Footer_12022025&utm_source=blog&utm_medium=internal&utm_content=link_brand_chi_nhanh_cua_sapo_tren_toan_quoc" style={{ textDecoration: "underline" }} target="_blank" rel="noopener noreferrer">
                  Xem thêm 24 chi nhánh của Sapo trên toàn quốc
                </Link>
              </p>
            </div>
          </div>
          <div className={classNames(styles["col-w-60"], "col-lg-5 offset-lg-5 col-12")}>
            <div className={styles.certi}>
              <a
                href="https://smg-aw.com/sapo-technology-joint-stock-company/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles["footer-dmca"]}
              >
                <Image width="59" height="62" src={process.env.NEXT_PUBLIC_BASE_PATH + "/images/iso1.png"} alt="ISO 27001:2022" />
              </a>
              <a
                href="https://smg-aw.com/sapo-technology-joint-stock-company/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles["footer-dmca"]}
              >
                <Image width="59" height="62" src={process.env.NEXT_PUBLIC_BASE_PATH + "/images/iso2.png"} alt="ISO 9001:2015" />
              </a>
              <a
                href="https://tinnhiemmang.vn/danh-ba-tin-nhiem/sapovn-1646215304"
                target="_blank"
                rel="noopener noreferrer"
                className={styles["footer-dmca"]}
              >
                <Image width="137" height="62" src={process.env.NEXT_PUBLIC_BASE_PATH + "/images/tinnhiemmang.png"} alt="Tín nhiệm mạng" />
              </a>
              <a href="https://support.sapo.vn/dieu-khoan-dieu-kien-su-dung" target="_blank" rel="noopener noreferrer" className={styles["footer-dcma"]}>
                <Image
                  src={process.env.NEXT_PUBLIC_BASE_PATH + "/images/bct-hanggia.webp"}
                  alt="Chứng nhận nói không với hàng giả - Bộ Công Thương"
                  width="62"
                  height="62"
                />
              </a>
              <a href="http://online.gov.vn/Home/WebDetails/44190?AspxAutoDetectCookieSupport=1" target="_blank" rel="noopener noreferrer" className={styles["footer-dcma"]}>
                <Image src={process.env.NEXT_PUBLIC_BASE_PATH + "/images/bocongthuong.png"} alt="Chứng nhận Bộ Công Thương" width="205" height="62" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default FooterAddress;
